import { render, staticRenderFns } from "./WhatIsOpenBanking.vue?vue&type=template&id=78c1f00a&scoped=true"
import script from "./WhatIsOpenBanking.vue?vue&type=script&lang=ts"
export * from "./WhatIsOpenBanking.vue?vue&type=script&lang=ts"
import style0 from "./WhatIsOpenBanking.vue?vue&type=style&index=0&id=78c1f00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1f00a",
  null
  
)

export default component.exports